export default "__VITE_ASSET__CsYe2BAx__"